import { createContext, useState } from 'react';

import OmeMeetEntryData from './OmeMeetEntryData';

export const OmeMeetEntryStateContext = createContext();

const OmeMeetEntryContextProvider = ({ children }) => {
  const stateHook = useState(OmeMeetEntryData.INITIAL_STATE);

  return (
    <OmeMeetEntryStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetEntryStateContext.Provider>
  );
};

export default OmeMeetEntryContextProvider;